export const idlFactory = ({ IDL }) => {
  const ErrorCategory = IDL.Variant({
    'SSHConnection' : IDL.Null,
    'ConfigurationIssue' : IDL.Null,
    'SSHAuthentication' : IDL.Null,
    'InfrastructureFailure' : IDL.Null,
    'Unknown' : IDL.Null,
    'DiscoveryOperation' : IDL.Null,
  });
  const ErrorSeverity = IDL.Variant({
    'Low' : IDL.Null,
    'High' : IDL.Null,
    'Medium' : IDL.Null,
    'Critical' : IDL.Null,
  });
  const ErrorPattern = IDL.Record({
    'component' : IDL.Text,
    'name' : IDL.Text,
    'negative_symptoms' : IDL.Vec(IDL.Text),
    'mutually_exclusive_with' : IDL.Vec(IDL.Text),
    'resolution_id' : IDL.Text,
    'library_indicators' : IDL.Vec(IDL.Text),
    'category' : ErrorCategory,
    'symptoms' : IDL.Vec(IDL.Text),
    'severity' : ErrorSeverity,
    'error_id' : IDL.Text,
    'root_cause' : IDL.Text,
  });
  const AnalysisRequest = IDL.Record({
    'context' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'error_message' : IDL.Text,
    'timestamp' : IDL.Nat64,
  });
  const Diagnosis = IDL.Record({
    'requires_human' : IDL.Bool,
    'matched_patterns' : IDL.Vec(IDL.Text),
    'recommended_fix' : IDL.Text,
    'resolution_steps' : IDL.Vec(IDL.Text),
    'confidence' : IDL.Float32,
    'error_id' : IDL.Opt(IDL.Text),
    'root_cause' : IDL.Text,
  });
  const DiagnosisRecord = IDL.Record({
    'request' : AnalysisRequest,
    'diagnosis' : Diagnosis,
    'timestamp' : IDL.Nat64,
  });
  return IDL.Service({
    'add_error_pattern' : IDL.Func([ErrorPattern], [], []),
    'analyze_error' : IDL.Func([AnalysisRequest], [Diagnosis], ['query']),
    'get_diagnosis_history' : IDL.Func(
        [IDL.Nat32],
        [IDL.Vec(DiagnosisRecord)],
        ['query'],
      ),
    'get_error_pattern' : IDL.Func(
        [IDL.Text],
        [IDL.Opt(ErrorPattern)],
        ['query'],
      ),
    'get_pattern_match_rate' : IDL.Func([], [IDL.Float32], ['query']),
    'get_statistics' : IDL.Func(
        [],
        [
          IDL.Record({
            'total_diagnoses' : IDL.Nat32,
            'total_patterns' : IDL.Nat32,
            'pattern_match_rate' : IDL.Float32,
            'avg_confidence' : IDL.Float32,
          }),
        ],
        ['query'],
      ),
    'list_error_patterns' : IDL.Func([], [IDL.Vec(ErrorPattern)], ['query']),
    'sync_patterns_from_kb' : IDL.Func([], [IDL.Nat32], []),
  });
};
export const init = ({ IDL }) => { return []; };
